/**
 * Date time picker type.
 */
export enum DateTimePickerType {
    DATE,
    TIME,
    DATETIME
}

/**
 * Date time picker variant.
 */
export enum DateTimePickerVariant {
    INLINE = 'inline',
    DIALOG = 'dialog',
    STATIC = 'static'
}
